import React from 'react';
import { useTranslation } from 'react-i18next';
import { helperMargin, Typography, Button } from '@utex/ui-kit';
import { Layout } from '../../../../../components/Layout';
import { createValidator, max, min, required } from '@unitedtraders/validators';
import { Form } from 'react-final-form';
import { useSubmit, FormValues } from '../../../../../hooks/useSubmit';
import { AmountInput } from '../../../../../components/AmountInput';
import { Notice } from './Notice';
import { Commission } from '../../../../../components/Commission';
import { ContentProps } from '../../../types';

export const RUBContent: React.FC<ContentProps> = ({ parameters }) => {
  const { t } = useTranslation('byCard');
  const { minimum, maximum, fee, paymentSystemId } = parameters;
  const { onSubmit } = useSubmit(paymentSystemId, 'RUB');

  const validate = createValidator({
    amount: [required(), min(minimum), max(maximum)],
  });

  return (
    <Form<FormValues>
      onSubmit={onSubmit}
      validate={validate}
      render={(form) => {
        const amount = form.values.amount || 0;

        return (
          <Layout.Form onSubmit={form.handleSubmit} noValidate>
            <Layout.FormContent>
              <AmountInput name="amount" amount={amount} currency="RUB" />
              <Typography.Paragraph size="M" css={helperMargin({ top: 10 })}>
                <Notice />
              </Typography.Paragraph>
            </Layout.FormContent>

            <Layout.FormFooter>
              <Button view="alert" type="submit">
                {t('Continue')}
              </Button>
              <Commission
                title={t('Card withdraw amount')}
                fee={fee}
                amount={amount}
                currency="RUB"
              />
            </Layout.FormFooter>
          </Layout.Form>
        );
      }}
    />
  );
};
